import React from 'react';
import { motion } from 'framer-motion';
import { SectionWrapper, childVariants } from './SectionWrapper';
export function MechanismSection() {
  return <SectionWrapper data-id="element-362">
      <motion.h2 className="font-heading text-2xl md:text-3xl font-bold text-cream mb-4" variants={childVariants} data-id="element-363">
        The Unique Mechanism
      </motion.h2>

      <motion.p className="font-heading text-xl md:text-2xl text-teal-light mb-12" variants={childVariants} data-id="element-364">
        The 3-Part Night‑Wake Protocol
      </motion.p>

      <motion.p className="font-body text-lg text-cream leading-loose-plus mb-12" variants={childVariants} data-id="element-365">
        This is the entire method, and it's designed for 3am brains:
      </motion.p>

      {/* Step 1 */}
      <motion.div className="mb-10" variants={childVariants} data-id="element-366">
        <div className="flex items-baseline gap-4 mb-3" data-id="element-367">
          <span className="font-heading text-3xl md:text-4xl font-bold text-teal/40" data-id="element-368">
            1
          </span>
          <h3 className="font-heading text-xl md:text-2xl font-semibold text-cream" data-id="element-369">
            Body Downshift
          </h3>
        </div>
        <p className="font-body text-lg text-cream-muted leading-loose-plus pl-12" data-id="element-370">
          A fast way to turn down the "on switch" in your nervous system.
        </p>
      </motion.div>

      {/* Step 2 */}
      <motion.div className="mb-10" variants={childVariants} data-id="element-371">
        <div className="flex items-baseline gap-4 mb-3" data-id="element-372">
          <span className="font-heading text-3xl md:text-4xl font-bold text-teal/40" data-id="element-373">
            2
          </span>
          <h3 className="font-heading text-xl md:text-2xl font-semibold text-cream" data-id="element-374">
            Brain Off‑Ramp
          </h3>
        </div>
        <p className="font-body text-lg text-cream-muted leading-loose-plus pl-12" data-id="element-375">
          Scripted exit ramps that stop racing thoughts without fighting them.
        </p>
      </motion.div>

      {/* Step 3 */}
      <motion.div className="mb-4" variants={childVariants} data-id="element-376">
        <div className="flex items-baseline gap-4 mb-3" data-id="element-377">
          <span className="font-heading text-3xl md:text-4xl font-bold text-teal/40" data-id="element-378">
            3
          </span>
          <h3 className="font-heading text-xl md:text-2xl font-semibold text-cream" data-id="element-379">
            Return‑to‑Sleep Ladder
          </h3>
        </div>
        <p className="font-body text-lg text-cream-muted leading-loose-plus pl-12" data-id="element-380">
          A strict sequence (stay in bed → sit up → brief exit) that prevents
          the frustration spiral and protects your bed from becoming a
          battlefield.
        </p>
      </motion.div>
    </SectionWrapper>;
}